module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.3dbc870.eot";